import React from 'react';
import Icon from '../../../components/AppIcon';

const ConversionTracker = ({ data }) => {
  const getCategoryIcon = (category) => {
    switch (category) {
      case 'Primary Conversions':
        return 'Target';
      case 'Micro-Conversions':
        return 'Zap';
      case 'Soft Engagements':
        return 'Heart';
      case 'Relationship Building':
        return 'Users';
      default:
        return 'Activity';
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'Primary Conversions':
        return 'bg-success/20 text-success';
      case 'Micro-Conversions':
        return 'bg-accent/20 text-accent';
      case 'Soft Engagements':
        return 'bg-secondary/20 text-secondary';
      case 'Relationship Building':
        return 'bg-info/20 text-info';
      default:
        return 'bg-primary/20 text-primary';
    }
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation border border-border">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-semibold text-foreground mb-1">Multi-Tier Engagement Tracking</h3>
          <p className="text-sm text-muted-foreground">Conversion funnel performance metrics</p>
        </div>
        <Icon name="TrendingUp" size={24} className="text-primary" />
      </div>
      <div className="space-y-6">
        {data?.map((category) => (
          <div key={category?.category} className="space-y-3">
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-lg ${getCategoryColor(category?.category)}`}>
                <Icon name={getCategoryIcon(category?.category)} size={20} />
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-foreground">{category?.category}</h4>
                <p className="text-xs text-muted-foreground">{category?.total?.toLocaleString()} total engagements</p>
              </div>
              <div className="text-right">
                <p className="text-lg font-bold text-foreground">{category?.conversionRate}%</p>
                <p className="text-xs text-muted-foreground">conversion</p>
              </div>
            </div>

            <div className="pl-12 space-y-2">
              {category?.metrics?.map((metric) => (
                <div key={metric?.name} className="flex items-center justify-between py-2 border-b border-border last:border-0">
                  <div className="flex items-center gap-2">
                    <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
                    <span className="text-sm text-foreground">{metric?.name}</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="text-sm font-medium text-foreground">{metric?.count?.toLocaleString()}</span>
                    <div className="flex items-center gap-1">
                      <Icon 
                        name={metric?.trend === 'up' ? 'ArrowUp' : metric?.trend === 'down' ? 'ArrowDown' : 'Minus'} 
                        size={14} 
                        className={metric?.trend === 'up' ? 'text-success' : metric?.trend === 'down' ? 'text-error' : 'text-muted-foreground'}
                      />
                      <span className={`text-xs ${metric?.trend === 'up' ? 'text-success' : metric?.trend === 'down' ? 'text-error' : 'text-muted-foreground'}`}>
                        {metric?.change}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConversionTracker;